/*
 * @Author: your name
 * @Date: 2020-03-02 19:14:12
 * @LastEditTime: 2020-08-12 15:34:34
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /nvoicep-h5/src/store/index.js
 */
import Vuex from 'vuex'

//引入模块
//模块文件名与相关的vue组件名称保持一致。
import zero from './modules/zero'
import global from './modules/global'
export default {
  install(Vue) {
    //使用Vuex插件
    Vue.use(Vuex)

    //创建store实例
    this.store = new Vuex.Store({
      modules: {
        zero,
        global
      }
    })
  },
  store: null//把store实例传递出去，用于Vue实例化方法的参数
}



// WEBPACK FOOTER //
// ./src/store/index.js